/**
 * PROVISIONING-STOCK-QR-6-FRONTEND — mensagens amigáveis da troca de equipamento.
 * Puro (testável). Mapeia o status HTTP do backend para texto ao usuário.
 */
import { PHYSICAL_QR_ERROR } from "./physicalQr.js";

export function replaceErrorMessage(err) {
  const st = err?.status;
  const msg = String(err?.message || "");
  if (st === 409) {
    return "Este QR já está vinculado a outra instalação. Use outro Sonoff ou verifique o estoque.";
  }
  if (st === 422) return PHYSICAL_QR_ERROR;
  if (st === 403) {
    return "Você não tem permissão para substituir este equipamento.";
  }
  if (st === 400 && /igual/i.test(msg)) return "O QR novo é igual ao QR atual.";
  if (st === 400) return msg || "Confirmação necessária para substituir.";
  if (st === 404) return "Vínculo não encontrado.";
  return msg || "Falha ao substituir o equipamento.";
}

export function replaceSuccessMessage(idempotent) {
  return idempotent
    ? "Este QR já estava preparado para este mesmo cliente. Nenhuma alteração adicional foi necessária."
    : "Substituição registrada. O novo equipamento ficará aguardando ligação/heartbeat para vincular.";
}
